"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TzmMetricId = void 0;
var TzmMetricId;
(function (TzmMetricId) {
    TzmMetricId["AddToCartRate"] = "addToCartRate";
    TzmMetricId["Exhaustiveness"] = "aliasesExhaustiveness, exhaustiveness";
    TzmMetricId["AttractivityRate"] = "attractivityRate";
    TzmMetricId["AvgConversionAfterDrag"] = "avgConversionAfterDrag";
    TzmMetricId["AvgConversionAfterFlick"] = "avgConversionAfterFlick";
    TzmMetricId["AvgConversionAfterSwipe"] = "avgConversionAfterSwipe";
    TzmMetricId["CoveredViewsCount"] = "coveredViewsCount";
    TzmMetricId["DragFlickRate"] = "dragFlickRate";
    TzmMetricId["DragFlickRecurrence"] = "dragFlickRecurrence";
    TzmMetricId["DragRate"] = "dragRate";
    TzmMetricId["DragRecurrence"] = "dragRecurrence";
    TzmMetricId["FlickRate"] = "flickRate";
    TzmMetricId["FlickRecurrence"] = "flickRecurrence";
    TzmMetricId["FoldHeight"] = "foldHeight";
    TzmMetricId["InteractionTime"] = "interactionTime";
    TzmMetricId["SrViewCount"] = "srViewCount";
    TzmMetricId["SrVisitCount"] = "srVisitCount";
    TzmMetricId["TotalHovers"] = "totalHovers";
    TzmMetricId["TransactionCount"] = "transactionCount";
    TzmMetricId["TransactionRate"] = "transactionRate";
    TzmMetricId["UncoveredViewsCount"] = "uncoveredViewsCount";
    TzmMetricId["UnitSoldCount"] = "unitSoldCount";
    TzmMetricId["ViewsWithClick"] = "viewsWithClick";
    TzmMetricId["ViewsWithHover"] = "viewsWithHover";
})(TzmMetricId = exports.TzmMetricId || (exports.TzmMetricId = {}));
//# sourceMappingURL=tzm-metric.js.map